import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LOGO_SRC from "../assets/logo";

const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const go = (path) => { navigate(path); window.scrollTo(0, 0); };

  const pages = [
    { label: t("nav.home"),         path: "/" },
    { label: t("nav.packages"),     path: "/packages" },
    { label: t("nav.destinations"), path: "/destinations" },
    { label: t("nav.about"),        path: "/about" },
    { label: t("nav.contact"),      path: "/contact" },
  ];

  return (
    <>
      <style>{`
        .footer { background:var(--deep); color:rgba(255,255,255,0.7); padding:70px 60px 30px; }
        .footer-grid { display:grid; grid-template-columns:1.8fr 1fr 1fr 1.4fr; gap:50px; margin-bottom:60px; }
        .footer-logo img { height:140px; width:auto; margin-bottom:18px; }
        .footer-desc { font-size:14px; line-height:1.8; max-width:280px; }
        .footer-contact-item { display:flex; align-items:flex-start; gap:10px; margin-bottom:14px; font-size:14px; }
        .footer-contact-icon { color:var(--gold); font-size:16px; margin-top:2px; flex-shrink:0; }
        .footer-heading { color:white; font-weight:600; font-size:13px; letter-spacing:2px; text-transform:uppercase; margin-bottom:20px; }
        .footer-link { display:block; color:rgba(255,255,255,0.6); font-size:14px; margin-bottom:10px; cursor:pointer; transition:color 0.2s; border:none; background:none; text-align:start; padding:0; font-family:inherit; }
        .footer-link:hover { color:var(--gold-light); }
        .footer-bottom { border-top:1px solid rgba(255,255,255,0.08); padding-top:24px; display:flex; justify-content:space-between; align-items:center; font-size:13px; }
        .footer-socials { display:flex; gap:12px; margin-top:20px; }
        .social-btn { width:36px; height:36px; border-radius:50%; border:1px solid rgba(201,168,76,0.3); display:flex; align-items:center; justify-content:center; color:var(--gold); font-size:14px; cursor:pointer; transition:all 0.2s; background:transparent; text-decoration:none; }
        .social-btn:hover { background:var(--gold); color:white; border-color:var(--gold); }
        @media(max-width:768px) {
          .footer { padding:50px 24px 24px; }
          .footer-grid { grid-template-columns:1fr; gap:32px; }
          .footer-bottom { flex-direction:column; gap:16px; text-align:center; }
          .footer-logo img { height:140px; }
        }
      `}</style>

      <footer className="footer">
        <div className="footer-grid">
          <div>
            <div className="footer-logo">
              <img src={LOGO_SRC} alt="Anassik Travel" />
            </div>
            <p className="footer-desc">{t("footer.desc")}</p>
            <div className="footer-socials">
              <a href="https://www.facebook.com/Anassik.Travel" target="_blank" rel="noreferrer" className="social-btn">f</a>
              <a href="https://www.instagram.com/anassik_travel" target="_blank" rel="noreferrer" className="social-btn">In</a>
              <a href="https://wa.me/212629291310" target="_blank" rel="noreferrer" className="social-btn">💬</a>
              <a href="mailto:contact@anassiktravel.com" className="social-btn">✉</a>
            </div>
          </div>

          <div>
            <div className="footer-heading">{t("footer.pages")}</div>
            {pages.map(p => (
              <button key={p.path} className="footer-link" onClick={() => go(p.path)}>{p.label}</button>
            ))}
          </div>

          <div>
            <div className="footer-heading">{t("footer.services")}</div>
            {t("footer.servicesList", { returnObjects: true }).map(s => (
              <span key={s} className="footer-link">{s}</span>
            ))}
          </div>

          <div>
            <div className="footer-heading">{t("footer.contactLbl")}</div>
            <div className="footer-contact-item"><span className="footer-contact-icon">📍</span><span>217 Amgala, 2ème étage, Appt N3, Ain Chok, Casablanca, Maroc</span></div>
            <div className="footer-contact-item"><span className="footer-contact-icon">📞</span><span>+212 665-009314<br/>+212 522 528080</span></div>
            <div className="footer-contact-item"><span className="footer-contact-icon">✉️</span><span>contact@anassiktravel.com</span></div>
            <div className="footer-contact-item"><span className="footer-contact-icon">🕐</span><span>{t("contact.hoursVal")}</span></div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>{t("footer.rights")}</span>
          <span style={{color:"rgba(255,255,255,0.35)"}}>{t("footer.country")}</span>
        </div>
      </footer>
    </>
  );
};

export default Footer;
